import React, { useCallback, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { followArtist, unfollowArtist } from '../redux/thunk/followedArtistsThunk';
import PillFace from './PillFace';

const FollowArtistButton = React.forwardRef(({ artist, prominent = false }, ref) => {
    const dispatch = useDispatch();
    const isAuthenticated = useSelector(state => state.auth.isAuthenticated);
    const followedSet = useSelector(state => state.followedArtists.followedSet);
    // .pop = confirmation beat on a user-initiated follow (prominent-pill CSS).
    const [pop, setPop] = useState(false);

    const name = artist.name || artist.artist_name;
    const isFollowed = name ? followedSet[name] : false;

    const handleClick = useCallback((e) => {
        e.stopPropagation();
        if (!isAuthenticated || !name) return;
        if (isFollowed) {
            setPop(false);
            // artwork: the unfollow toast's image when this artist isn't in
            // the loaded Favourite Artists page.
            dispatch(unfollowArtist({ artistName: name, artwork: artist.artwork || artist.artworkUrl || null }));
        } else {
            setPop(true);
            dispatch(followArtist(artist));
        }
    }, [dispatch, isAuthenticated, isFollowed, name, artist]);

    if (!isAuthenticated || !name) return null;

    // Person + star — matches the "Favourite Artists" icon in the sidebar.
    // When followed, the whole glyph (person + star) fills in.
    const icon = (
        <svg width="28" height="28" viewBox="0 0 24 24" fill={isFollowed ? 'currentColor' : 'none'} stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/>
            <circle cx="9" cy="7" r="4"/>
            <polygon points="18 12 19.8 15.5 23.5 16 21 18.5 21.5 22 18 20 14.5 22 15 18.5 12.5 16 16.2 15.5" fill={isFollowed ? 'currentColor' : 'none'} stroke="currentColor" strokeWidth="1.5"/>
        </svg>
    );

    return (
        <button
            ref={ref}
            className={`follow-artist-btn${prominent ? ' prominent' : ''}${isFollowed ? ' following' : ''}${pop ? ' pop' : ''}`}
            title={isFollowed ? 'Following — saved to your artists and feed' : 'Follow — save this artist and personalise your feed'}
            onClick={handleClick}
            onAnimationEnd={(e) => { if (e.animationName === 'pill-pop') setPop(false); }}
        >
            {prominent ? <PillFace icon={icon} label={isFollowed ? 'Following' : 'Follow'} longest="Following" /> : icon}
        </button>
    );
});

export default FollowArtistButton;
